// @flow

import { Component } from '../jsti/core';
import EventNames from '../constants/EventNames';
import Notifications from '../constants/Notifications';

export default class SearchIcon extends Component {
  /**
   * Initialize the component
   *
   * @param pEl
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);

    this.addEventListener(EventNames.CLICK, this.onClick.bind(this));
  }

  /**
   * Executes on click
   */
  onClick(): void {
    this.notify(Notifications.FOCUS_ON_SEARCH);
  }
}
